module.exports = __webpack_public_path__ + "static/media/Germanaising.6bff6ddf.gif";